(function (angular) {
    'use strict';

    //Si se le pasa un ejemplarId: se trata de las páginas digitalizadas de un ejemplar
    //Si se le pasa un edicionId: se trata de las imágenes de las ilustraciones de una edición
    angular
        .module('app')
        .component('imagenes', {
            bindings: {
                elements: '=',
                mode: '<',
                ejemplarId: '<',
                edicionId: '<',
                ilustracionId: '<',
                // propietarioId: '<'
                // selected: '='
                idBloque: '@',
                mensaje: '@' //Mensaje para mostrar en el boton
            },
            templateUrl: 'app/components/form/imagenes/imagenes.form.html',
            /* @ngInject */
            controller: function ($timeout) {
                var vm = this;
                vm.imagenes = angular.copy(vm.elements);

                $timeout(function () {
                    angular.element('.form-group:eq(0)>input').focus();
                });

                function cleanList() {
                    if (typeof(vm.elements) == 'undefined') {
                        vm.elements = [];
                    }
                    vm.elements = vm.elements.filter(function (imagen) {
                        return imagen.path;
                    });
                }

                if (vm.ejemplarId) {
                    vm.rutaCarpetaImagen = "upload/ejemplares/" + vm.ejemplarId + "/pagsDigitalizadas";
                } else {
                    if (vm.edicionId && vm.ilustracionId) {
                        vm.rutaCarpetaImagen = "upload/ediciones/" + vm.edicionId + "/ilustraciones/" + vm.ilustracionId;
                    } else {
                        console.log("No proporcionó información suficiente para encontrar el elemento multimedia");
                    }
                }


                // *** Imágenes ***

                function initImagenes() {
                    if (!vm.elements || !vm.elements.length) {
                        vm.elements = [];
                    }
                    addEmptyImagen();
                }

                function addEmptyImagen() {
                    vm.elements.push({});
                    vm.sortableOptions();
                }

                vm.onUploadedImage = function () {
                    addEmptyImagen();
                };

                vm.onRemoveImage = function (imagen) {
                    // if (imagen.principal) {
                    //     vm.selected = 0;
                    // }
                    // vm.elements.splice(vm.elements.indexOf(imagen), 1);
                };

                vm.sortableOptions = function () {
                    if (vm.imagenes) {
                        if (vm.imagenes.length < (vm.elements.length - 1)) {
                            vm.imagenes = vm.imagenes.concat(vm.elements[(vm.elements.length - 2)]);
                        }
                        for (i = 0; i < vm.imagenes.length; i++) {
                            vm.imagenes[i].orden = i + 1;
                            vm.elements[i] = angular.copy(vm.imagenes[i]);
                        }
                    }
                };

                cleanList();
                initImagenes();

                // initPrincipal();

                //El último elemento de la lista es vacío, ya que se corresponde con el boton de "añadir"
                //Para evitar que sea un elemento ordenable, es necesario crear una nueva lista sin dicho elemento, y pasarsela al sv-part
                if (vm.elements.length > 1) {
                    vm.imagenes = angular.copy(vm.elements);
                    vm.imagenes.splice(-1, 1);
                }
            },
            controllerAs: 'formCtrl'
        });
})(angular);
